import React from 'react';
import { ChevronRight } from 'src/shared/design-system/Icon';
import {
  Contents,
  HeaderIconContainer,
  PanelContainer,
  PanelHeader,
  PanelHeaderContainer,
  PanelHeaderWrapper,
  PanelSubHeader,
  PanelWrapper,
} from './styles';
import { Title } from './Title';
import { PanelHeaderSectionProps, PanelProps } from './types';

export const PanelHeaderSection: React.FC<PanelHeaderSectionProps> = (props) => {
  const { className, darkBackground, header, subHeader, padded, to } = props;
  return (
    <PanelHeaderContainer to={to} darkBackground={darkBackground} className={className}>
      <PanelHeaderWrapper>
        <PanelHeader padded={padded} data-role='panel-header'>
          {header}
        </PanelHeader>
        {subHeader && (
          <PanelSubHeader padded={padded} data-role='panel-subheader'>
            {subHeader}
          </PanelSubHeader>
        )}
      </PanelHeaderWrapper>
      {to && (
        <HeaderIconContainer>
          <ChevronRight />
        </HeaderIconContainer>
      )}
    </PanelHeaderContainer>
  );
};

export const PanelComponent: React.FC<React.PropsWithChildren<PanelProps>> = (props) => {
  const {
    children,
    className,
    darkBackground,
    emphasize,
    fullHeight = false,
    header,
    id,
    noContentPadding,
    subHeader,
    to,
  } = props;
  return (
    <PanelContainer className={className} fullHeight={fullHeight} emphasize={emphasize} id={id}>
      {header && (
        <PanelHeaderSection darkBackground={darkBackground} header={header} subHeader={subHeader} to={to} padded />
      )}
      {children && <Contents noContentPadding={noContentPadding}>{children}</Contents>}
    </PanelContainer>
  );
};

// eslint-disable-next-line functional/immutable-data -- Assign Panel Component
export const Panel = Object.assign(PanelComponent, { HeaderSection: PanelHeaderSection, Title, Wrapper: PanelWrapper });
